// utils/stringTools.js

/**
 * Convertit une chaîne en slug utilisable comme "name" ou identifiant.
 * Ex: "Taille " → "taille"
 */
export function slugify(str = '', maxLength = 40) {
  return str
    .normalize('NFD') // supprime les accents
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '')
    .slice(0, maxLength);
} 